export interface SnapshotData {
  cupo_snapshot: number;
  process_limit_snapshot: number;
  fecha_sync: string; // ISO date
}

const SNAPSHOT_WEBHOOK = 'https://hook.us1.make.com/ad2wgg2r9dfvv2an610eqrhpepadh8ng';

export async function fetchSnapshot(psychologistId: string): Promise<SnapshotData> {
  const url = `${SNAPSHOT_WEBHOOK}?psychologist_id=${encodeURIComponent(psychologistId)}`;
  const res = await fetch(url, { signal: AbortSignal.timeout(10_000) });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return {
    cupo_snapshot: data.slot_snapshot,
    process_limit_snapshot: data.process_limit,
    fecha_sync: data.created_at,
  };
}
